import React from "react";
import { HiDotsVertical } from "react-icons/hi";
import profile_Img from "../../../../Assets/Images/multipleUsers.png";

export default function GroupHeader({
  totalUsers,
  setShowProfileView,
  channelActiveChat,
  setActiveSection,
}) {
  return (
    <div className="px-[10px] flex justify-between items-center w-full">
      <div
        onClick={() => {
          setActiveSection("contact");
          setShowProfileView(true);
        }}
        className="flex items-center cursor-pointer"
      >
        <div>
          {channelActiveChat?.mediaId?.imageUrl ? (
            <img
              src={channelActiveChat.mediaId.imageUrl}
              alt="avatars"
              className="w-[46px] h-[46px] rounded-full object-cover"
            />
          ) : (
            <div
              className="w-[46px] h-[46px] flex items-center justify-center rounded-full shadow-sm"
              style={{
                background:
                  "linear-gradient(to bottom right, rgb(139 92 246), rgb(217 70 239))",
              }}
            >
              <span className="text-white font-bold text-lg">
                {channelActiveChat?.channelName
                  ? channelActiveChat.channelName
                    .split(" ")
                    .map((word) => word[0])
                    .join("")
                    .toUpperCase()
                    .slice(0, 2)
                  : "#"}
              </span>
            </div>
          )}
        </div>
        <div className="flex flex-col justify-start ml-4">
          <span className="cursor-pointer hover:text-[var(--primary-color)] font-semibold text-sm text-black dark:text-gray-300 pb-1.5 text-left">
            {channelActiveChat?.channelName}
          </span>
          <div className="flex items-center space-x-1">
            <span className="text-xs font-normal text-[#7C7C7C] line-clamp-2 overflow-hidden text-ellipsis break-words">
              {totalUsers} Follower{totalUsers > 1 && "s"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
